import React, { useCallback, useMemo, useReducer, useRef } from 'react';
import styles from './index.module.scss';
import cx from "classnames";
import RenderContent from "../index";
import {Link} from "react-router-dom";
import CustomLink from "../../../CustomLink";

import arr from '../../../../assets/icons/arrows/arrow_down.svg';
import DynamicToggle from "../../../HOC/DynamicToggle";
import {parseIconUrl} from "../../../../helpers/utils";

interface Props {
  items: DynamicObjectType[]
}

const ExpandableContentContainer = ({items}: Props) => {
  const openedSectionsIds = useRef(new Set())
  const [expandedIds, toggle] = useReducer((state: number[], id: number | number[]) => {
    if(Array.isArray(id)) return id
    if(state.includes(id)) {
      openedSectionsIds.current.add(id)
      return state.filter(elId => elId !== id)
    }
    return [...state, id]
  }, items.reduce<number[]>((result, {startExpanded}, i) => {
    return startExpanded ? [...result, i] : result
  }, []));
  // eslint-disable-next-line
  const forceUpdate = useMemo(() => ({}), [items]);

  const toggleAll = useCallback(() => {
    if(expandedIds.length !== items.length) toggle(items.map((_, i) => i))
    else toggle([])
  }, [expandedIds.length, items]);

  const handleClick = useCallback((i: number, e: any) => {
    e.preventDefault()
    toggle(i)
  }, [toggle])
  return(
    <div className={styles.root}>
      <p className={styles.link} onClick={toggleAll}>
        {expandedIds.length >= items.length ? 'Collapse all' : 'Expand all'}
      </p>

      <div className={styles.list}>
        {items.map((item, i) => {
          if(!item.innerContent) return null
          const isOpen = expandedIds.includes(i);
          return (
            <div className={cx(styles.item, {[styles.active]: isOpen})} key={i}>
              <Link to={"#"} preventScrollReset className={cx(styles.header, {[styles.active]: openedSectionsIds.current.has(i)})} onClick={handleClick.bind(null, i)} rel={'nofollow'} >
                {item.content.iconName && <img src={parseIconUrl(item.content.iconName)} alt={'icon'} />}
                {item.content.url ? (
                  <CustomLink to={item.content.url} className={styles.underline} onClick={(e) => e.preventDefault()}>
                    <p className={styles.header__title}>{item.content.title}</p>
                  </CustomLink>
                ) : (
                  <p className={styles.header__title}>{item.content.title}</p>
                )}
                <img src={arr} alt="arr" className={styles.header__arr}/>
              </Link>
              <DynamicToggle isActive={isOpen} extraSpacing={250} forceUpdate={forceUpdate}>
                <div className={styles.content}>
                  {item.innerContent.map((item, i) => <RenderContent {...item} key={i} />)}
                </div>
              </DynamicToggle>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default React.memo(ExpandableContentContainer)
